// Tells the server which physical handset this is, once per app open.
//
// In a plugin rather than on a screen because it belongs to neither of them. Both kinds
// of phone need identifying — a partner's phone at a sponsored area and one of ours on a
// workshop door — and they land on different pickers, so hanging this off either one
// would leave half the fleet anonymous until something went wrong on it.
//
// Reporting it here, rather than only inside a support request, is what lets the fleet
// dashboard name a phone before anybody needs to find it in a hurry.
export default defineNuxtPlugin((nuxtApp) => {
  const { reportIdentity } = useProvisioning()

  // On mount rather than immediately, so this cannot race the plugin that restores the
  // pairing from storage: without the token there is nothing to report against, and the
  // alternative is depending on the order two plugins happen to run in.
  nuxtApp.hook('app:mounted', () => {
    // Not awaited, and it never rejects. Nothing on screen is waiting for this, and a
    // phone must never be held at a splash screen over book-keeping.
    reportIdentity()
  })
})
